'use strict';

// Single Sign On Service shared component meant to be used
// in eZ Platform and magento

class SSOService {
    
    constructor(options) {
        this.options = options;
        this.logDebug(['SSOService initialized', options]);
    }
    
    logDebug(msg) {
        if (this.options.debug)
        {
            console.log(msg);
        }
    }
    
    callApi(url,data) {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest(); 
            xhr.withCredentials = true;
            xhr.open("post", url, true);
            xhr.addEventListener('error', () => {
                this.logDebug('request failed with error');
                reject();
            });
            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    this.logDebug(['API request successfull', xhr]);
                    resolve(JSON.parse(xhr.responseText));
                } else {
                    console.warn(xhr);
                    reject(this.statusText);
                }
            });
            xhr.addEventListener('abort', () => {
                console.warn(xhr.statusText, xhr.responseText);
                reject(this.statusText);
            });
            
            xhr.send(JSON.stringify(data));
        });
    }
    
    isUserLoggedIn() {
        return new Promise((resolve, reject) => {
            this.getState().then(
                responseJSON => {
                    this.logDebug(responseJSON);
                    
                    if (responseJSON.status === 'Connected')
                    {
                        return resolve(responseJSON.token);
                    }
                    
                    reject();
                    
                },
                reject
            ); 
        });
    }
    
    getState(token = "") {
        return this.callApi(
            this.options.baseUrl + "?action=getState",
            {
                token: token 
            }
        );
    }
    
    login(login, password) {
        
        this.logDebug('trying login...');
        
        return new Promise((resolve, reject) => {
            this.callApi(
                this.options.baseUrl + "?action=login",
                {
                    login : login,
                    password : password
                }
            )
                .then(
                    responseJSON => {
                        this.logDebug(['answer from login request', responseJSON]);
                        if (responseJSON.status === 'Success')
                        {
                            return resolve(responseJSON.token);
                        }
                        
                        reject(responseJSON.errorMessage);
                    }
                )
                .catch(reject);
        });
    }

    logout() {
        return this.callApi(this.options.baseUrl + "?action=logout");
    }
    
}

export default SSOService;